module.exports = __webpack_public_path__ + "img/Postmodernisme_Gro-Dahle.a5f6bed4.jpg";